module.exports = __webpack_public_path__ + "static/media/ciudades.08ded998.svg";